export const Repo = () => {
    return (
        <div>
            thanks for visiting my site! view the repo for this website <a href="https://github.com/nareha/nareh">here</a>.
        </div>
    );
};
